import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  public async saveAs(data: Blob, filename: string): Promise<void> {
    saveAs(data, filename);
  }
}
